import React from 'react';

const EmbedForm = ({ onSubmit, isVideo, onUrlInput, disabled }) => (
  <form onSubmit={onSubmit}>
    <input
      disabled={disabled}
      className="EditorElement-uploadButton NewInput NewInput--light"
      type="url"
      onInput={onUrlInput}
      placeholder={t('lessons.editor.embeds.video.url_field_hint')}
      required
    />
    <div className="d-f f-sh-0">
      <button
        disabled={disabled}
        className="NewButton NewButton--white"
        type="submit"
      >
        {isVideo
          ? t('lessons.editor.embeds.video.submit_button_text')
          : t('common.submit')}
      </button>
    </div>
  </form>
);

export default EmbedForm;
